import type { CustomDetector } from 'i18next-browser-languagedetector';

/**
 * Reads the culture from the cookie ASP.NET Core's request localization writes.
 *
 * The value is not a bare culture — `UseRequestLocalization` stores
 * `c=it-IT|uic=it-IT`, where `uic` is the UI culture that selects translations.
 * The stock cookie detector would hand that whole string to i18next as a
 * language name and detection would silently fall back to the default, so the
 * value is parsed here instead.
 *
 * Having this detector keeps one language choice shared between the Razor pages
 * and the SPA while both are reachable.
 */
export const ASPNET_CULTURE_COOKIE = '.AspNetCore.Culture';

export const aspNetCultureDetector: CustomDetector = {
  name: 'aspNetCulture',

  lookup() {
    const match = document.cookie.match(
      new RegExp(`(?:^|; )${ASPNET_CULTURE_COOKIE.replace(/\./g, '\\.')}=([^;]*)`),
    );
    if (!match) return undefined;

    const value = decodeURIComponent(match[1]);
    // Prefer uic (UI culture) — it is the one that drives translation lookup;
    // c only affects number and date formatting.
    const uic = value.match(/uic=([^|]+)/);
    if (uic) return uic[1];

    const culture = value.match(/c=([^|]+)/);
    return culture ? culture[1] : undefined;
  },
};
